import { render, staticRenderFns } from "./blog-presentation.vue?vue&type=template&id=9f95a3e4&"
import script from "./blog-presentation.vue?vue&type=script&lang=js&"
export * from "./blog-presentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports